import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Form, FormGroup, FormControl, Button } from "react-bootstrap";
import { CardNumberElement, CardExpiryElement, CardCvcElement, ElementsConsumer } from "@stripe/react-stripe-js";

import Api from "../utils/Api";

import AuthorizeService from "./api-authorization/AuthorizeService";

class CheckoutForm extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {};

		this.handleSubmit = this.handleSubmit.bind(this);
		this.reloadToken = this.reloadToken.bind(this);
		this.handleCardUserNameChange = this.handleCardUserNameChange.bind(this);
		this.handleCardPostalChange = this.handleCardPostalChange.bind(this);
	}

	async handleSubmit(event)
	{
		// We don't want to let default form submission happen here, which would refresh the page.
		event.preventDefault();

		const cardElement = this.props.elements.getElement(CardNumberElement);
		const stripeResult = await this.props.stripe.createToken(cardElement, {
			name: this.state.cardName,
			address_zip: this.state.postalCode
		});
		const token = stripeResult.token;
		console.log("Received Stripe token:", token);
		if (token)
		{
			try
			{
				const response = await Api.upgradeToPremium(token);
				// TODO: BA-151 redirect
				console.log(response);

				await this.reloadToken();
			}
			catch (message)
			{
				// TODO: BA-152 handle error
				console.error(message);
			}
		}
		else
		{
			alert("Card Authorization failed.");
		}
	}

	async reloadToken()
	{
		// In order to reload the token, we need to call signIn
		const returnUrl = window.location.origin; // Redirect to homepage
		await AuthorizeService.signIn({ returnUrl });

		// TODO: is that true?? copied from Login.jsx
		// It's important that we do a replace here so that we remove the callback uri with the
		// fragment containing the tokens from the browser history.
		window.location.replace(returnUrl);
	}

	handleCardUserNameChange(event)
	{
		this.setState({ cardName: event.target.value });
	}

	handleCardPostalChange(event)
	{
		this.setState({ postalCode: event.target.value });
	}

	render()
	{
		const {cardName, postalCode} = this.state;

		return (
			<Form horizontal onSubmit={this.handleSubmit}>
				<FormGroup>
					<Row>
						<Col sm={2}>
							Name
						</Col>
						<Col sm={10}>
							<FormControl type="text" placeholder="Name" value={cardName || ""} onChange={this.handleCardUserNameChange}/>
						</Col>
					</Row>
					<Row>
						<Col sm={2}>
							Card Number
						</Col>
						<Col sm={10}>
							<CardNumberElement className="form-control" />
						</Col>
					</Row>
					<Row>
						<Col sm={2}>
							Expiration Date
						</Col>
						<Col sm={10}>
							<CardExpiryElement className="form-control" />
						</Col>
					</Row>
					<Row>
						<Col sm={2}>
							CVC
						</Col>
						<Col sm={10}>
							<CardCvcElement className="form-control" />
						</Col>
					</Row>
					<Row>
						<Col sm={2}>
							Postal Code
						</Col>
						<Col sm={10}>
							<FormControl type="text" placeholder="12345" value={postalCode || ""} onChange={this.handleCardPostalChange}/>
						</Col>
					</Row>
					<Row>
						<Button type="submit">Upgrade me!</Button>
					</Row>
				</FormGroup>
			</Form>
		);
	}
}

CheckoutForm.propTypes = {
	elements: PropTypes.object,
	stripe: PropTypes.object
};

const InjectedCheckoutForm = () => (
	<ElementsConsumer>
		{({stripe, elements}) => (
			<CheckoutForm stripe={stripe} elements={elements} />
		)}
	</ElementsConsumer>
);

export default InjectedCheckoutForm;



// WEBPACK FOOTER //
// ./Components/components/CheckoutForm.jsx